<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="horario" titulo="Horario / Coordinación"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 0em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <span id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 79vh;">
                <a id="imprimir_local" (click)="asignarLogos(ctrl.logos64); generarPDF(ctrl.dato[ctrl.contador]); "></a>
                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th><abbr>ID</abbr></th>
                            <th>Periodo Escolar</th>
                            <th>Grupo</th>
                            <th>Carrera</th>
                            <th>Modalidad</th>
                            <th>Turno</th>
                            <th>Plan</th>
                            <!-- <th>Grupo</th>
                            <th>Nivel</th> -->

                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <th style="vertical-align: middle;">{{ i + 1 }}</th>
                            <td style="vertical-align: middle;">
                              <span *ngIf="item.periodos_escolares" title="Periodo" class="fa fa-calendar fa-2x is-success"></span>
                             {{ item.periodos_escolares?.nombre }}
                            </td>
                            <td style="vertical-align: middle;">{{ item.grupos?.clave }} / {{ item.grupos?.nivel }} {{ item.grupos?.identificador }}</td>
                            <td style="vertical-align: middle;">{{ item.carreras_planes?.carreras?.nombre }}</td>
                            <td style="vertical-align: middle;">{{ item.modalidades?.nombre }} </td>
                            <td style="vertical-align: middle;">{{ item.turnos?.nombre }} </td>
                            <td style="vertical-align: middle;">{{ item.carreras_planes?.planes_estudios?.nombre }}</td>

                            <!-- <td style="vertical-align: middle;">{{ item.grupos?.clave }} </td>
                            <td style="vertical-align: middle;">{{ item.grupos?.nivel }} </td> -->


                            <td style="vertical-align: middle;" class="has-text-centered">
                              <!-- acciones -->
                              <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="7" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                            <figure class="image is-64x64">
                                <span *ngIf="item.periodos_escolares" title="Periodo" class="fa fa-calendar fa-5x is-success"></span>
                            </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="tag  is-black">
                                            ID: {{item.id}}
                                        </strong>

                                        <strong class="tag  is-success">
                                             Periodo Escolar: {{ item.periodos_escolares?.nombre }}
                                        </strong>

                                        <strong class="tag ">
                                            Carrera/Plan: {{ item.carreras_planes?.carreras?.nombre }} / {{ item.carreras_planes?.planes_estudios?.nombre }}
                                        </strong>

                                        <strong class="tag ">
                                            Modalidad: {{ item.modalidades?.nombre }}
                                        </strong>

                                        <strong class="tag  is-link">
                                            Grupo: {{ item.grupos?.clave }}
                                        </strong>

                                        <strong class="tag  is-link">
                                          Nivel: {{ item.grupos?.nivel }}
                                        </strong>

                                        <strong class="tag ">
                                            Turno: {{ item.turnos?.nombre }}
                                        </strong>

                                        <strong class="tag ">
                                            Creado: {{ item.created_at | formatoFecha:'DD/MM/YYYY' }}
                                        </strong>
                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>

<div *ngIf="imprimirhorario">
  <div *ngFor="let modulo of ph_modulos; let i = index">
    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tablahorario{{i}}">
      <thead>
        <tr>
          <th width="200">Hora/Día</th>
          <th *ngFor="let dia of ph_dias">{{dia}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let hora of ph_horas">
          <td>
            <div>{{hora.split('-')[0]}}</div>
            <div>{{hora.split('-')[1]}}</div>
          </td>
          <td *ngFor="let dia of ph_dias">
            <div *ngIf="profesorhorario.horario[modulo][dia]" align="center">
              <div>{{profesorhorario.horario[modulo][dia][hora]?.nombre}}</div>
              <small>{{profesorhorario.horario[modulo][dia][hora]?.clave}}</small>
              <div>{{profesorhorario.horario[modulo][dia][hora]?.docente}}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
